export default [
	{
		path: 'balance',
		name: 'erp_storage_balance',
		component: () => import('@/pages/erp/stock_balance_list')
	},
	{
		path: 'ledger',
		name: 'erp_storage_ledger',
		component: () => import('@/pages/erp/storage_ledger_list')
	}
];
